import { createContext, useContext } from 'react';
import { IBillContext, ClaimsTypeTypes, IBill, BillClaimsSelectedType } from '../../models/Bills.interfaces';
import { AxiosError } from 'axios';

type BillsContextType = {
    bills: IBill[];
    bill: IBillContext;
    billsToDownload: Set<string>;
    isDownloadCompleted: boolean;
    billsDownloaded: string[];
    billsWithError: string[];
    downloadError: AxiosError | null;
    billsZip: Blob | null;
    claimType: ClaimsTypeTypes;
    billClaimsSelected: Set<string>;
    claims: BillClaimsSelectedType[];
    claimId: string;
    claimComment: string;
    customerAccount: string;
    setBills: (value: IBill[]) => void;
    setBill: (value: IBillContext) => void;
    setBillsToDownload: (value: Set<string>) => void;
    setIsDownloadCompleted: (value: boolean) => void;
    setBillsDownloaded: (value: string[]) => void;
    setBillsWithError: (value: string[]) => void;
    setDownloadError: (value: AxiosError | null) => void;
    setBillsZip: (value: Blob | null) => void;
    setClaimsType: (value: ClaimsTypeTypes) => void;
    setBillClaimsSelected: React.Dispatch<React.SetStateAction<Set<string>>>;
    setClaimId: React.Dispatch<React.SetStateAction<string>>;
    setClaims: React.Dispatch<React.SetStateAction<BillClaimsSelectedType[]>>;
    resetClaimValues: () => void;
    setClaimComment: React.Dispatch<React.SetStateAction<string>>;
    setCustomerAccount: React.Dispatch<React.SetStateAction<string>>;
};

export const BillsContext = createContext({} as BillsContextType);

export const useBillsContext = () => {
    const context = useContext(BillsContext);

    if (!context) throw new Error('useBillsContext must be used within a BillsProvider');

    return context;
};
